import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Submit request", body: "Pick your bars or a custom weight and send the order request — no account needed." },
  { n: "02", title: "Assay & contract", body: "Our Monrovia desk confirms the quotation, assay documentation and sales contract." },
  { n: "03", title: "Secure settlement", body: "Payment settles through escrow-backed channels agreed with your institution." },
  { n: "04", title: "Insured dispatch", body: "Bars are sealed, serial-verified and dispatched under fully insured transit." },
];

const ProcessSection = () => (
  <section id="process" className="py-24 lg:py-32 bg-[#FAF8F5] border-t border-[#E6E0D4]">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl mb-14"
      >
        <p className="text-xs font-medium tracking-[0.3em] uppercase text-[#8C6D27] mb-4">How wholesale works</p>
        <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1816]">
          From request to vault in four moves.
        </h2>
      </motion.div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={`process-step-${s.n}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1], delay: i * 0.09 }}
            className="h-full bg-white border border-[#E6E0D4] p-7 hover:border-[#C5A059]/70 transition-colors duration-500"
          >
            <p className="font-mono text-sm text-[#C5A059]">{s.n}</p>
            <h3 className="font-serif text-xl text-[#1A1816] mt-4">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#6E6A63] font-light">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSection;
